import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const FileImage = ({ path, alt = "", className = "" }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!path) return undefined;
    let alive = true;
    let url = null;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        url = URL.createObjectURL(r.data);
        if (alive) setSrc(url);
      })
      .catch(() => {});
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);
  if (!src) {
    return <div className={`animate-pulse bg-cream-dark ${className}`} aria-hidden="true" />;
  }
  return <img src={src} alt={alt} className={className} />;
};
